<div class="edit-page-root-container task-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" [readonly]="taskInfo.id!==undefined && taskInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code is required</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" maxlength="100">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left" style="display: flex; align-items: center; gap: 20px; padding-bottom: 20px;">
                                <mat-checkbox formControlName="is_active">Is Active</mat-checkbox>
                            </div>
                            <div class="input-box-right" style="display: flex; gap: 10px;">
                                <mat-form-field style="flex: 1; display: none;">
                                    <mat-label>FG Color</mat-label>
                                    <input matInput type="color" formControlName="fg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                                <mat-form-field style="flex: 1;">
                                    <mat-label>Color</mat-label>
                                    <input matInput type="color" formControlName="bg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
